import { Grid, MenuItem, TextField, Typography } from "@mui/material";
import { Option } from "../../../main/components/SelectInput";
import { CalledCategoryEnum } from "../../calleds/types";
import { MultipleFilesDropzone } from "../../../main/components/MultipleFilesDropzone";
import { useEffect, useState } from "react";

const getCalledCategoryByType: Record<string, string> = {
  [CalledCategoryEnum.BUG.toString()]: "BUG",
  [CalledCategoryEnum.DUVIDA.toString()]: "Dúvida",
  [CalledCategoryEnum.SEGESTAO_MELHORIA.toString()]: "Sugestão ou Melhoria",
  [CalledCategoryEnum.OUTRO.toString()]: "Outro",
};
type NewCalledFormProps = {
  data: {
    descricao?: string | undefined;
    category?: number | undefined;
    files?: File[] | undefined;
  },
  setData: React.Dispatch<React.SetStateAction<{
    descricao?: string;
    category?: number;
    files?: File[];
  }>>
};
export default function NewCalledForm(props: NewCalledFormProps) {

  const categoryOptions: Option[] = Object.keys(getCalledCategoryByType).map(
    (key) => ({
      value: key,
      label: getCalledCategoryByType[key],
    })
  );

  const [file, setFile] = useState<File[] | null>(null);

  useEffect(() => {
    setData({
      ...data,
      files: file ?? undefined,
    });
  }, [file]);

  const { data, setData } = props;

  return (
    <>
      <Grid
        container
        sx={{
          width: "95%",
          height: "100%",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              size="small"
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                },
              }}
              inputProps={{
                style: {
                  fontSize: 16,
                },
              }}
              select
              label="Categoria"
              value={data.category}
              onChange={(e) =>
                setData({
                  ...data,
                  category: e.target.value ? Number(e.target.value) : undefined,
                })
              }
            >
              <MenuItem value={undefined}>Selecione</MenuItem>
              {categoryOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="outlined-multiline-static"
              label="Descrição"
              multiline
              rows={4}
              value={data.descricao}
              onChange={(e) => setData({ ...data, descricao: e.target.value })}
              fullWidth
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography sx={{ fontSize: "18px", fontWeight: "400", color: "#b3b3b3ff", paddingLeft: "15px", paddingBottom: "10px" }}>Anexos:</Typography>
            <MultipleFilesDropzone
              onUpload={(files) => setFile(files)}
              setUploadedFile={setFile}
              uploadedFile={data.files ? data.files : null}
              label={"Arraste documentos aqui, ou clique para selecionar!"}
              sx={{ height: "250px" }}
            />
          </Grid>
        </Grid>
      </Grid>


    </>
  );
}
